import { useCallback, useSyncExternalStore } from "react"

const STORAGE_KEY = "desktopMapHidden"

const subscribers = new Set<() => void>()

const read = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true"
  } catch {
    return false
  }
}

// Cross-tab sync via the window `storage` event is intentionally out of scope —
// this subscriber set only coordinates consumers within the same tab/session.
const subscribe = (listener: () => void): (() => void) => {
  subscribers.add(listener)
  return () => {
    subscribers.delete(listener)
  }
}

const setDesktopMapHidden = (hidden: boolean): void => {
  try {
    localStorage.setItem(STORAGE_KEY, hidden ? "true" : "false")
  } catch {
    // localStorage may be unavailable (private mode / disabled storage);
    // notify subscribers anyway so the in-memory UI still reacts this session.
  }
  subscribers.forEach((listener) => listener())
}

export const useDesktopMapHidden = (): [boolean, (hidden: boolean) => void] => {
  const hidden = useSyncExternalStore(subscribe, read, read)
  const setHidden = useCallback((value: boolean) => {
    setDesktopMapHidden(value)
  }, [])
  return [hidden, setHidden]
}
